module.exports = __webpack_public_path__ + "static/media/tech-nextgen-2.cd27199b.png";